import React from 'react';
import UtilityService from '../../../services/UtilityService';
import { GiftCardContract } from '../../../types/GiftCard';
import LinkButton from '../../input/LinkButton';
import Checkmark from '../Checkmark';

interface AppliedGiftCardProps {
  giftCard: GiftCardContract;
  onRemoveGiftCardClicked: (giftCardCode: string) => Promise<void>;
}

export const AppliedGiftCardTestId = 'AppliedGiftCard-content';

const AppliedGiftCard: React.FC<AppliedGiftCardProps> = ({
  giftCard,
  onRemoveGiftCardClicked,
}: AppliedGiftCardProps) => {
  return (
    <div data-testid={AppliedGiftCardTestId} className="max-h-9 flex flex-flow">
      <span className="w-1/12 pl-2 pt-1 max-w-max">
        <Checkmark />
      </span>
      <span className="pl-2">
        Using Gift Card Code{' '}
        <strong>{UtilityService.formatGiftCardCode(giftCard.code)}</strong> with
        a balance of{' '}
        <strong>{UtilityService.formatAmount(giftCard.value, '$')}</strong>.{' '}
        <LinkButton
          btnColor="text-red-600"
          onClick={() => onRemoveGiftCardClicked(giftCard.code)}
          toolTipKey="AppliedGiftCard"
        >
          <span className="pl-1">Remove</span>
        </LinkButton>
      </span>
    </div>
  );
};

export default AppliedGiftCard;
